export default __webpack_public_path__ + "static/media/noun_dental veneer_1946265.b9b905f8.png";